import { useContext } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { LicenseInfo } from '@mui/x-data-grid-pro'
import CssBaseline from '@mui/material/CssBaseline'
import makeStyles from '@mui/styles/makeStyles'
import { SnackbarProvider } from 'notistack'
import { SwalProvider } from 'genesis-suite/components'
import withAuth from './lib/withAuth'
import { routes } from './lib/routes'
import { TopNav, SideNav } from './components/nav'
import { AuthContext } from './components/contexts/AuthContext'
import { CloudProvider } from './components/contexts/CloudContext'
import { authService } from './lib/services'
import { DomainProvider } from './components/contexts/DomainContext'
import ActAsSnackbar from './components/act-as/ActAsSnackbar'
import './App.css'

LicenseInfo.setLicenseKey(
    'f12314dd03314d4d4d3dd1f709938dd3T1JERVI6Mzc0ODYsRVhQSVJZPTE2NzU5NjE4ODEwMDAsS0VZVkVSU0lPTj0x'
)

const useStyles = makeStyles(({ custom }) => ({
    main: {
        height: `calc(100% - ${custom.topNavHeight}px)`,
        display: 'flex',
    },
    content: {
        flex: '1 1 auto',
        overflowX: 'hidden',
        overflowY: 'auto',
        marginLeft: 240, // Width of side nav
    },
}))

setInterval(() => authService.ping(), 5 * 60 * 1000)

const App = () => {
    const { user, actAs } = useContext(AuthContext)
    const classes = useStyles()

    return (
        <div className="App" style={{ border: actAs ? '5px solid #069d8e' : '' }}>
            <SwalProvider>
                <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <CloudProvider>
                        <DomainProvider>
                            <CssBaseline />
                            <TopNav />
                            <main className={classes.main}>
                                {user && <SideNav />}
                                <div className={classes.content}>
                                    <Routes>
                                        {routes.map(route => {
                                            const {
                                                path,
                                                private: secured,
                                                adminOnly,
                                                superUserOnly,
                                                component,
                                            } = route
                                            const Component = secured
                                                ? withAuth({ component, adminOnly, superUserOnly })
                                                : component
                                            return <Route key={path} path={path} element={<Component />} />
                                        })}
                                        <Route path="*" element={<Navigate to="/" />} />
                                    </Routes>
                                </div>
                            </main>
                            {user && <ActAsSnackbar />}
                        </DomainProvider>
                    </CloudProvider>
                </SnackbarProvider>
            </SwalProvider>
        </div>
    )
}

export default App
